import { writable } from 'svelte/store';

// Strip the locale prefix (e.g. /en, /pl) from the current path.
const localeRe = /^\/((?:[a-z]{2})(?:-[A-Z]{2})?)(?=\/|$)/;
const localeMatch = window.location.pathname.match(localeRe);

export const locale = localeMatch ? localeMatch[1] : '';
const prefix = locale ? `/${locale}` : '';

const strip = (path) => path.slice(prefix.length) || '/';

const routes = {
  '/login':         () => import('./LoginForm.svelte'),
  '/register':      () => import('./RegisterForm.svelte'),
  '/password/new':  () => import('./ForgotPasswordForm.svelte'),
  '/password/edit': () => import('./ResetPasswordForm.svelte'),
  '/confirm/new':   () => import('./ResendConfirmationForm.svelte'),
};

export const currentView  = writable(null);
export const currentRoute = writable('');

export async function navigate(path, push = true) {
  const fullPath = prefix + path;
  if (push) window.history.pushState({}, '', fullPath);
  currentRoute.set(path);

  const loader = routes[path] || routes['/login'];
  const mod = await loader();
  currentView.set(mod.default);
}

export function locate() {
  navigate(strip(window.location.pathname), false);
}
